// tab/src/components/common/Loading.tsx
// OnRounds Phase 2 - Loading Component

import React from 'react';
import { Spinner, Text, makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '200px',
    ...shorthands.gap('16px'),
  },
});

interface LoadingProps {
  message?: string;
}

export const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size="large" />
      <Text>{message}</Text>
    </div>
  );
};
